<template>
  <div v-if="filteredNews.length" class="news-section row-40-25 p-bottom-xxl-1">
    <div class="news-section__list">
      <div
        v-for="(block, index) in filteredNews"
        :key="index"
        class="news-section__list__item"
      >
        <div class="news-section__list__item__content">
          <div class="news-section__list__item__image" v-if="block.mainImage">
            <WidgetPicture
              :image="{ custom: block.mainImage.responsiveImage }"
              :alt="block.mainImage.alt"
            />
          </div>
          <div class="news-section__list__item__text">
            <p class="news-section__list__item__pre-title">
              {{ $t('menu.news') }}
            </p>
            <p class="news-section__list__item__title">
              {{ block.name }}
            </p>
            <div class="news-section__list__item__link" data-no-cursor>
              <WidgetArrowLink
                :label="$t('cta.discover')"
                :link="
                  localePath({
                    name: 'event-slug',
                    params: { slug: block.slug },
                  })
                "
                :is-secondary="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonNewsSection',
}
</script>

<script setup>
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
})

const filteredNews = computed(() => {
  return props.data.filter((newsItem) => {
    var userEntered = new Date(newsItem.startDate) 
    var now = new Date()
    var today = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
    )
    if (userEntered.getTime() >= today.getTime()) {
      return newsItem
    }
  });
});
</script>

<style lang="scss">
@import './style.scss';
</style>
